import { toastr } from 'react-redux-toastr';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const SAVE_ACCOUNT_REVIEW_COMMENTS_REQUEST = 'SAVE_ACCOUNT_REVIEW_COMMENTS_REQUEST';
export const SAVE_ACCOUNT_REVIEW_COMMENTS_SUCCESS = 'SAVE_ACCOUNT_REVIEW_COMMENTS_SUCCESS';
export const SAVE_ACCOUNT_REVIEW_COMMENTS_FAILURE = 'SAVE_ACCOUNT_REVIEW_COMMENTS_FAILURE';

function requestSaveAccountReviewComments() {
  return {
    type: SAVE_ACCOUNT_REVIEW_COMMENTS_REQUEST,
    isSavingFormReviewState: true,
  };
}

function receiveSaveAccountReviewComments(accountReview) {
  return {
    type: SAVE_ACCOUNT_REVIEW_COMMENTS_SUCCESS,
    isSavingFormReviewState: false,
    accountReview,
    formReviewStateError: null
  };
}

function rejectSaveAccountReviewComments(formReviewStateError) {
  return {
    type: SAVE_ACCOUNT_REVIEW_COMMENTS_FAILURE,
    isSavingFormReviewState: false,
    formReviewStateError
  };
}

export function saveAccountReviewComments(formId, accountId, draftComments) {
  const formData = new FormData();
  formData.append('reviewerComment', draftComments);

  return (dispatch) => {
    dispatch(requestSaveAccountReviewComments());

    const promise = () => ApiService
      .saveAccountReviewComments(formId, accountId, formData)
      .then((response) => {
        dispatch(receiveSaveAccountReviewComments(response.data));
        toastr.success('Success', 'Comments saved successfully');
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectSaveAccountReviewComments, true));
        }
      });
    return promise();
  };
}
